import { render, staticRenderFns } from "./coamaping.vue?vue&type=template&id=37a5dff4"
import script from "./coamaping.vue?vue&type=script&lang=js"
export * from "./coamaping.vue?vue&type=script&lang=js"
import style0 from "./coamaping.vue?vue&type=style&index=0&id=37a5dff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports